/*
  Quick JS by Jason @ freakdesign.
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page
*/
(function () {
  'use strict';

  var debug = false;
  var currentProvince = '';
  var cartRoot = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) || '/';
  var productInfo = document.querySelector('.product__info-container');
  var pendingCustomerCart = null;
  var isFetchingRates = false;
  var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');

  var cepRanges = {
    Acre: [{ start: 69900000, end: 69999999 }],
    Alagoas: [{ start: 57000000, end: 57999999 }],
    Amapá: [{ start: 68900000, end: 68999999 }],
    Amazonas: [
      { start: 69000000, end: 69299999 },
      { start: 69400000, end: 69899999 }
    ],
    Bahia: [{ start: 40000000, end: 48999999 }],
    Ceará: [{ start: 60000000, end: 63999999 }],
    'Distrito Federal': [
      { start: 70000000, end: 72799999 },
      { start: 73000000, end: 73699999 }
    ],
    'Espírito Santo': [{ start: 29000000, end: 29999999 }],
    Goiás: [
      { start: 72800000, end: 72999999 },
      { start: 73700000, end: 76799999 }
    ],
    Maranhão: [{ start: 65000000, end: 65999999 }],
    'Mato Grosso': [{ start: 78000000, end: 78899999 }],
    'Mato Grosso do Sul': [{ start: 79000000, end: 79999999 }],
    'Minas Gerais': [{ start: 30000000, end: 39999999 }],
    Pará: [{ start: 66000000, end: 68899999 }],
    Paraíba: [{ start: 58000000, end: 58999999 }],
    Paraná: [{ start: 80000000, end: 87999999 }],
    Pernambuco: [{ start: 50000000, end: 56999999 }],
    Piauí: [{ start: 64000000, end: 64999999 }],
    'Rio de Janeiro': [{ start: 20000000, end: 28999999 }],
    'Rio Grande do Norte': [{ start: 59000000, end: 59999999 }],
    'Rio Grande do Sul': [{ start: 90000000, end: 99999999 }],
    Rondônia: [{ start: 76800000, end: 76999999 }],
    Roraima: [{ start: 69300000, end: 69399999 }],
    'Santa Catarina': [{ start: 88000000, end: 89999999 }],
    'São Paulo': [{ start: parseInt('01000000', 10), end: 19999999 }],
    Sergipe: [{ start: 49000000, end: 49999999 }],
    Tocantins: [{ start: 77000000, end: 77999999 }]
  };

  if (shippingCalcExist) {
    return;
  }

  var productSection = document.querySelector('.shopping-calculator');
  if (!productSection) {
    log('Could not find the element');
    return;
  }

  var productSelect = document.querySelector('.product__info-container .product-form form input[name="id"]');
  if (!productSelect) {
    log('Could not find the main select element');
    return;
  }

  var calc = window.shippingCalculator || {};
  var shippingCountry = document.createElement('select');
  var shippingProvince = document.createElement('select');

  var shippingFormStructure =
    '<div class="shipping-calc-wrapper v-stack gap-4">' +
    '<p class="shipping-calc__title h6">' +
    (calc.shippingEstimatorTitle || 'Calcular frete') +
    '</p>' +
    '<div class="shipping-calc__form-row">' +
    '<input value="" id="shipping-calculator-input" class="input" type="text" name="shipping_address[zip]" inputmode="numeric" autocomplete="postal-code" maxlength="9" placeholder="' +
    (calc.zipPlaceholder || '00000-000') +
    '" aria-label="' +
    (calc.zipLabel || 'CEP') +
    '" />' +
    '<button type="button" class="button shippingCalcButton">' +
    (calc.estimateButton || 'Calcular') +
    '</button>' +
    '</div>' +
    '<p class="shipping-calc__hint text-subdued">' +
    '<span class="shipping-calc__hint-label">' +
    (calc.zipLabel || 'CEP') +
    '</span> ' +
    '<a class="link" target="_blank" rel="noopener noreferrer" href="https://buscacepinter.correios.com.br/app/endereco/index.php">' +
    (calc.dontKnowZip || 'Não sei meu CEP') +
    '</a>' +
    '</p>' +
    '<div class="shipping-calc__results message" role="region" aria-live="polite" hidden></div>' +
    '</div>';

  productSection.innerHTML = shippingFormStructure;

  var shippingCalcWrapper = document.querySelector('.shipping-calc-wrapper');
  var shippingZip = document.querySelector('#shipping-calculator-input');
  var shippingCalcButton = document.querySelector('.shippingCalcButton');
  var shippingMessage = document.querySelector('.shipping-calc__results');
  var buttonDefaultLabel = shippingCalcButton.textContent.trim();
  var cepInputTimer;

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatCepDisplay(digits) {
    if (digits.length <= 5) {
      return digits;
    }

    return digits.slice(0, 5) + '-' + digits.slice(5);
  }

  function isValidCep(value) {
    return digitsOnly(value).length === 8;
  }

  function getBrazilStateFromCep(zipRaw) {
    var cep = digitsOnly(zipRaw);

    if (cep.length !== 8) {
      currentProvince = '';
      return '';
    }

    var cepNumber = parseInt(cep, 10);
    var estado;

    for (estado in cepRanges) {
      if (!Object.prototype.hasOwnProperty.call(cepRanges, estado)) {
        continue;
      }

      var ranges = cepRanges[estado];
      for (var i = 0; i < ranges.length; i++) {
        if (cepNumber >= ranges[i].start && cepNumber <= ranges[i].end) {
          currentProvince = estado;
          setProvinceValue(estado);
          return estado;
        }
      }
    }

    currentProvince = '';
    return '';
  }

  function setProvinceValue(value) {
    for (var j = 0; j < shippingProvince.options.length; j++) {
      if (shippingProvince.options[j].value === value) {
        shippingProvince.selectedIndex = j;
        return;
      }
    }
  }

  function clearShippingError() {
    shippingZip.classList.remove('shipping-calc__input--invalid');
    shippingZip.removeAttribute('aria-invalid');
  }

  function showShippingError(message) {
    shippingCalcWrapper.classList.remove('shipping-calc--loading');
    shippingZip.classList.add('shipping-calc__input--invalid');
    shippingZip.setAttribute('aria-invalid', 'true');
    shippingMessage.className = 'shipping-calc__results message error';
    shippingMessage.innerHTML = message;
    shippingMessage.hidden = false;
  }

  function getCarrierName(rate) {
    return rate.presentment_name || rate.name || '';
  }

  function formatDeliveryLabel(rate) {
    var daysCount = null;

    if (rate.delivery_days && rate.delivery_days.length > 0) {
      daysCount = parseInt(rate.delivery_days[0], 10);
    }

    if (daysCount === 0) {
      return calc.deliveryToday || 'Em até 24h úteis';
    }

    if (daysCount === 1) {
      return 'Em até 1 dia útil';
    }

    if (daysCount > 1) {
      return 'Em até ' + daysCount + ' dias úteis';
    }

    return '';
  }

  function setButtonLoading(isLoading) {
    shippingCalcButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    shippingCalcButton.disabled = isLoading;
    shippingCalcWrapper.classList.toggle('shipping-calc--loading', isLoading);

    if (!isLoading) {
      shippingCalcButton.textContent = buttonDefaultLabel;
    }
  }

  function syncProvinceFromCepInput() {
    var digits = digitsOnly(shippingZip.value);
    shippingZip.value = formatCepDisplay(digits);
    clearShippingError();

    if (digits.length === 8) {
      getBrazilStateFromCep(digits);
    } else {
      currentProvince = '';
    }
  }

  function resetShippingResults() {
    shippingMessage.innerHTML = '';
    shippingMessage.hidden = true;
    shippingMessage.className = 'shipping-calc__results message';
    clearShippingError();
    setButtonLoading(false);
  }

  function bindQuantityReset() {
    if (!productInfo) {
      return;
    }

    productInfo.addEventListener('change', function (event) {
      if (event.target.matches('.quantity-selector__input')) {
        resetShippingResults();
      }
    });

    productSelect.addEventListener('change', function () {
      resetShippingResults();
    });

    window.addEventListener('pagehide', function () {
      if (pendingCustomerCart !== null) {
        restoreCustomerCart(pendingCustomerCart);
        pendingCustomerCart = null;
      }
    });
  }

  function initFields() {
    var countries = ['Brazil'];
    for (var i = 0; i < countries.length; i++) {
      shippingCountry.add(new Option(countries[i], countries[i], i === 0));
    }
    shippingCountry.name = 'shipping_address[country]';

    var provinces = [
      'Acre', 'Alagoas', 'Amapá', 'Amazonas', 'Bahia', 'Ceará', 'Distrito Federal', 'Espírito Santo', 'Goiás',
      'Maranhão', 'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Pará', 'Paraíba', 'Paraná', 'Pernambuco',
      'Piauí', 'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondônia', 'Roraima',
      'Santa Catarina', 'São Paulo', 'Sergipe', 'Tocantins'
    ];
    for (var j = 0; j < provinces.length; j++) {
      shippingProvince.add(new Option(provinces[j], provinces[j]));
    }
    shippingProvince.name = 'shipping_address[province]';

    shippingZip.addEventListener('input', function () {
      clearTimeout(cepInputTimer);
      cepInputTimer = setTimeout(syncProvinceFromCepInput, 400);
    });

    shippingZip.addEventListener('blur', syncProvinceFromCepInput);

    shippingCalcButton.onclick = function () {
      shippingMessage.innerHTML = '';
      shippingMessage.hidden = true;
      shippingMessage.className = 'shipping-calc__results message';
      clearShippingError();

      if (!productSelect.value.length) {
        return false;
      }

      if (!isValidCep(shippingZip.value)) {
        showShippingError(calc.shippingEstimatorMessageError || 'Por favor, insira um CEP válido.');
        return false;
      }

      if (!currentProvince) {
        getBrazilStateFromCep(shippingZip.value);
      }

      if (!currentProvince) {
        showShippingError(calc.shippingEstimatorMessageError || 'Por favor, insira um CEP válido.');
        return false;
      }

      getRates(parseInt(productSelect.value, 10));
      return false;
    };

    bindQuantityReset();
  }

  function log(a) {
    if (!debug) {
      return;
    }
    console.log(a);
  }

  var getCookie = function (name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
  };

  function restoreCartCookie(token) {
    if (!token) {
      return;
    }

    var date = new Date();
    date.setTime(date.getTime() + 14 * 86400000);
    document.cookie = 'cart=' + token + '; expires=' + date.toUTCString() + '; path=/';
  }

  function expireCartCookie() {
    document.cookie = 'cart=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }

  function getProductQuantity() {
    var input = productInfo ? productInfo.querySelector('quantity-selector .quantity-selector__input') : null;
    var quantity = input ? parseInt(input.value, 10) : 1;

    if (!quantity || quantity < 1) {
      quantity = 1;
    }

    return quantity;
  }

  function cartFetch(url, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = Object.assign(
      {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      options.headers || {}
    );

    return fetch(cartRoot + url, options);
  }

  function restoreCustomerCart(savedToken) {
    if (savedToken) {
      restoreCartCookie(savedToken);
    } else {
      expireCartCookie();
    }

    return Promise.resolve();
  }

  function prepareEstimateCart(variantId, quantity) {
    pendingCustomerCart = getCookie('cart') || null;

    // Seta um token fake para forçar o Shopify a criar um carrinho temporário limpo.
    // Isso preserva o carrinho real do cliente sem precisar do cart/clear.js.
    restoreCartCookie('estimate-' + Date.now());

    return cartFetch('cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw data;
        }

        return data;
      });
    });
  }

  function finishEstimateRequest() {
    var savedToken = pendingCustomerCart;

    pendingCustomerCart = null;
    return restoreCustomerCart(savedToken);
  }

  function renderShippingRates(rates) {
    if (!rates || !rates.length) {
      showShippingError(calc.noDelivery || calc.shippingEstimatorMessageError);
      return;
    }

    var messageHtml = '<ul class="shipping-calc__rates">';

    for (var i = 0; i < rates.length; i++) {
      var element = rates[i];
      var carrierName = getCarrierName(element);
      var deliveryLabel = formatDeliveryLabel(element);
      var deliveryInfoHtml = '';

      if (carrierName || deliveryLabel) {
        deliveryInfoHtml =
          '<span class="shipping-calc__rate-name">' +
          (carrierName ? '<span>' + carrierName + '</span>' : '') +
          (deliveryLabel ? '<span class="shipping-calc__rate-delivery text-subdued">' + deliveryLabel + '</span>' : '') +
          '</span>';
      }

      var deliveryPrice;
      if (element.price === '0.00') {
        deliveryPrice = '<span class="shipping-calc__rate-price free-shipping">' + calc.shippingFree + '</span>';
      } else {
        deliveryPrice = '<span class="shipping-calc__rate-price">R$ ' + element.price.replace('.', ',') + '</span>';
      }

      messageHtml += '<li class="shipping-calc__rate">' + deliveryInfoHtml + deliveryPrice + '</li>';
    }

    messageHtml += '</ul>';
    shippingMessage.className = 'shipping-calc__results message';
    shippingMessage.innerHTML = messageHtml;
    shippingMessage.hidden = false;
  }

  function pollAsyncRates(searchParams, attempt) {
    attempt = attempt || 0;

    return cartFetch('cart/async_shipping_rates.json?' + searchParams.toString())
      .then(function (response) { return response.text(); })
      .then(function (text) {
        if (text === 'null') {
          if (attempt >= 40) {
            throw new Error('shipping_rates_timeout');
          }

          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(pollAsyncRates(searchParams, attempt + 1));
            }, 250);
          });
        }

        var parsed = JSON.parse(text);
        return parsed.shipping_rates || [];
      });
  }

  function fetchShippingRates(searchParams) {
    return cartFetch('cart/prepare_shipping_rates.json?' + searchParams.toString(), { method: 'POST' })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) { throw err; });
        }
      })
      .then(function () {
        return pollAsyncRates(searchParams);
      });
  }

  var getRates = function (variantId) {
    if (typeof variantId === 'undefined') {
      setButtonLoading(false);
      return;
    }

    if (isFetchingRates) {
      return;
    }

    isFetchingRates = true;
    setButtonLoading(true);

    var leftoverToken = pendingCustomerCart;
    pendingCustomerCart = null;

    var quantity = getProductQuantity();
    var zipDigits = digitsOnly(shippingZip.value);
    var searchParams = new URLSearchParams({
      'shipping_address[country]': shippingCountry.value,
      'shipping_address[province]': currentProvince,
      'shipping_address[zip]': zipDigits
    });

    var start = leftoverToken !== null
      ? restoreCustomerCart(leftoverToken).catch(function () {})
      : Promise.resolve();

    start
      .then(function () {
        return prepareEstimateCart(variantId, quantity);
      })
      .then(function () {
        return fetchShippingRates(searchParams);
      })
      .then(function (rates) {
        renderShippingRates(rates);
      })
      .catch(function (err) {
        if (err && (err.zip || err.shipping_address)) {
          showShippingError(calc.shippingEstimatorMessageError || 'Por favor, insira um CEP válido.');
        } else {
          showShippingError(calc.shippingRetryError || 'Não foi possível calcular o frete. Clique em Calcular novamente.');
        }
      })
      .finally(function () {
        finishEstimateRequest()
          .catch(function () {})
          .finally(function () {
            isFetchingRates = false;
            setButtonLoading(false);
          });
      });
  };

  initFields();
})();
